<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div id="content" class="app-content" style="background-color: #f8f8f8">
        <div>
            <b-tabs card content-class="" ref="theTab" v-model="tabIndex" @input="activateTab">
                <b-tab active>
                    <template v-slot:title>
                        <strong style="display: inline-block;padding:0 2px" ><em class="far fa-clipboard"></em> Main</strong>
                    </template>
                    <template>
                        <AgGridForm01 :tabs="tabs"
                                      :tabCounter="tabCounter"
                                      @tabIndex="tabIndexData" ref="AgGridForm01">
                        </AgGridForm01 >
                    </template>
                </b-tab>
                <b-tab @click="tabTranslateId(tab)" title="Data"
                       v-for="tab in this.tabs" :name="tab.title" :label="tab.title"
                       :key=tab.length ref="'Tab' + tab.i" active>
                    <template v-slot:title>
                        <strong style="display: inline-block;padding:0 2px" ><em class="far fa-clipboard"></em> {{tab.title}}</strong> <a v-on:click="tabClose(tab.i)"><i class="fa fa-times-circle"></i></a>
                    </template>
                    <template>
                        <formInputInfo
                            :tabs="tabs"
                            @tabIndex="tabIndexData"
                            :tabId="tab.id"
                            :onlyIdsTab="onlyIds"
                            :showType="showType"
                            @getCaseInfo="getCaseInfo"
                        ></formInputInfo>
                    </template>
                </b-tab>
            </b-tabs>
        </div>
    </div>
</template>

<script>
    import AgGridForm01 from "../../layouts/components/case/agGridForm"
    import FormInputInfo from "../../layouts/components/case/formDetail"

    export default {
        name: "User",
        components: {
            FormInputInfo,
            AgGridForm01,
        },
        watch: {
            '$route': function () {},
        },
        data() {
            return {
                tabs: [],
                tabCounter: 0,
                tabIndex: 0,
                onlyIds:'',
                showType:'Case',
            }
        },
        methods: {
            tabIndexData(val) {  //获取下标的值
                this.tabIndex = val;
            },
            getCaseInfo(val){},
            tabClose: function (x) {
                for (let i = 0; i < this.tabs.length; i++) {
                    if (this.tabs[i].i === x) {
                        this.tabs.splice(i, 1)
                    }
                }
            },
            activateTab(n){},
            tabTranslateId(tab){
                this.onlyIds=tab.onlyId;
                this.showType = tab.type;
            },
        }
    }
</script>

